<div odxLayout="flex vertical-center" class="container scroll">
  <odx-header id="header" odxLayout="12">
    <odx-header-title>
      <div odxLayout="flex vertical-center">
        <a href="#" odxLayout="flex vertical-center" data-testid="navintaLogo">
          <img src="assets/navinta_logo.svg" alt="navinta logo" />
        </a>
        <a href="#"> Navinta</a>
      </div>
    </odx-header-title>
  </odx-header>
  <div class="odx-display-md" i18n="@@scopeSelection.header1">Welcome to Navinta!</div>

  <h5 class="odx-heading-5" i18n="@@scopeSelection.header2">
    Please enter your business scope, country and language. <br />
    The business scope cannot be changed afterwards.
  </h5>

  <div odxLayout="flex horizontal-center" class="cards-container">
    <app-scope-selection-card
      [isSelected]="selectedScope === scopeCardsDetails.fgds.scope"
      [scope]="scopeCardsDetails.fgds"
      (selectScope)="setSelectedScope($event)"
    ></app-scope-selection-card>
    <app-scope-selection-card
      [isSelected]="selectedScope === scopeCardsDetails.monitoring.scope"
      [scope]="scopeCardsDetails.monitoring"
      (selectScope)="setSelectedScope($event)"
    ></app-scope-selection-card>
  </div>

  <form odxForm [formGroup]="localeSelectionForm">
    <app-language-selection-form-field
      [disabled]="!selectedScope"
      [formGroup]="localeSelectionForm"
      [languages]="supportedLanguagesBySelectedScope"
      [label]="languageFormFieldLabel"
      (selectLanguage)="setSelectedLanguage($event)"
    ></app-language-selection-form-field>
    <app-country-selection-form-field
      [disabled]="!selectedScope"
      [formGroup]="localeSelectionForm"
      [countries]="supportedCountriesBySelectedScope"
      [label]="countryFormFieldLabel"
      (selectCountry)="setSelectedCountry($event)"
    ></app-country-selection-form-field>

    <button
      odxButton
      variant="highlight"
      [disabled]="!localeSelectionForm.valid"
      (click)="onSubmit()"
      i18n="@@scopeSelection.form.confirm"
    >
      Confirm
    </button>
  </form>

  <footer odxLayout="flex">
    <odx-logo size="medium" variant="default"></odx-logo>
    <p class="odx-heading-6">Technik für das Leben</p>
  </footer>
</div>
